import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Feeling",
    opening: localizedGenderNode(
      [
      "Today I do not try to fix myself.",
      "I only notice: there is a feeling of not belonging in me."
    ],
      [
      "Today I do not try to fix myself.",
      "I only notice: there is a feeling of not belonging in me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is this feeling strongest?",
      "What rises in me with it?",
      "What inner sentence repeats?"
    ],
      [
      "When is this feeling strongest?",
      "What rises in me with it?",
      "What inner sentence repeats?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A feeling is an experience, not an identity."
    ],
      [
      "A feeling is an experience, not an identity."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I see the feeling\".",
      "one breath + \"I see the feeling\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The Moment It Appears",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the feeling rises.",
      "I only notice."
    ],
      [
      "Today I notice the moment the feeling rises.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens right before it rises?",
      "Who is around me when it appears?",
      "What am I afraid will happen there?"
    ],
      [
      "What happens right before it rises?",
      "Who is around me when it appears?",
      "What am I afraid will happen there?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When the moment is clear, I have a little space."
    ],
      [
      "When the moment is clear, I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the feeling rises.",
      "one breath when the feeling rises."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ],
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does the feeling sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where does the feeling sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to protect me."
    ],
      [
      "My body is trying to protect me."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ],
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the bare fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the bare fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "My Comparison",
    opening: localizedGenderNode(
      [
      "Today I see how comparison feeds the feeling.",
      "I only notice."
    ],
      [
      "Today I see how comparison feeds the feeling.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit quietly for a moment.",
      "One breath."
    ],
      [
      "I sit quietly for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who am I comparing myself to?",
      "What do I believe is missing in me there?",
      "What do I bring with me?"
    ],
      [
      "Who am I comparing myself to?",
      "What do I believe is missing in me there?",
      "What do I bring with me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Comparison is a habit, not a truth."
    ],
      [
      "Comparison is a habit, not a truth."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"I do not have to compare\".",
      "an inner sentence - \"I do not have to compare\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Inner Voice",
    opening: localizedGenderNode(
      [
      "Today I listen to the voice that says \"I don't belong\".",
      "Without fighting it."
    ],
      [
      "Today I listen to the voice that says \"I don't belong\".",
      "Without fighting it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my inner voice.",
      "One breath."
    ],
      [
      "I notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does that voice sound?",
      "What is it trying to protect?",
      "What would I like to say to it?"
    ],
      [
      "How does that voice sound?",
      "What is it trying to protect?",
      "What would I like to say to it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A voice is just a voice."
    ],
      [
      "A voice is just a voice."
    ]
    ),
    action: localizedGenderNode(
      "notice it without believing it.",
      "notice it without believing it."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Need to Belong",
    opening: localizedGenderNode(
      [
      "Today I touch the need to belong.",
      "I stay with myself."
    ],
      [
      "Today I touch the need to belong.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel I belong?",
      "Where do I feel I belong?",
      "What is a small moment of belonging for me?"
    ],
      [
      "What do I need to feel I belong?",
      "Where do I feel I belong?",
      "What is a small moment of belonging for me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Belonging is a human need."
    ],
      [
      "Belonging is a human need."
    ]
    ),
    action: localizedGenderNode(
      "write one moment when I did feel I belonged.",
      "write one moment when I did feel I belonged."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Anchor",
    opening: localizedGenderNode(
      [
      "Today I choose a small anchor when I am with people.",
      "Not a big one."
    ],
      [
      "Today I choose a small anchor when I am with people.",
      "Not a big one."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my feet.",
      "One breath."
    ],
      [
      "I feel my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with myself?",
      "What small anchor is possible for me?",
      "How does it feel when I stay with myself?"
    ],
      [
      "What helps me stay with myself?",
      "What small anchor is possible for me?",
      "How does it feel when I stay with myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small anchor can be enough."
    ],
      [
      "A small anchor can be enough."
    ]
    ),
    action: localizedGenderNode(
      "feel my feet for a moment.",
      "feel my feet for a moment."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "A Soft Inner Language",
    opening: localizedGenderNode(
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ],
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ],
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I speak to myself when I feel I don't belong?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ],
      [
      "How do I speak to myself when I feel I don't belong?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle voice lowers pressure."
    ],
      [
      "A gentle voice lowers pressure."
    ]
    ),
    action: localizedGenderNode(
      "say the gentle sentence once.",
      "say the gentle sentence once."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Before I Hide",
    opening: localizedGenderNode(
      [
      "Today I pause a moment before I shut down.",
      "Just a moment."
    ],
      [
      "Today I pause a moment before I shut down.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to hide.",
      "One breath."
    ],
      [
      "I notice the urge to hide.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I know I am shutting down?",
      "What am I trying to protect there?",
      "What could help me stay a moment?"
    ],
      [
      "How do I know I am shutting down?",
      "What am I trying to protect there?",
      "What could help me stay a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small pause changes the story."
    ],
      [
      "A small pause changes the story."
    ]
    ),
    action: localizedGenderNode(
      "one breath before I shut down.",
      "one breath before I shut down."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Return to the Present",
    opening: localizedGenderNode(
      [
      "Today I return to this moment.",
      "I am with myself."
    ],
      [
      "Today I return to this moment.",
      "I am with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel the weight of my body.",
      "One breath."
    ],
      [
      "I feel the weight of my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ],
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The present gives me ground."
    ],
      [
      "The present gives me ground."
    ]
    ),
    action: localizedGenderNode(
      "feel my feet for a moment.",
      "feel my feet for a moment."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A Moment Before Pulling Back",
    opening: localizedGenderNode(
      [
      "Today I pause a moment before I pull away.",
      "Just a moment."
    ],
      [
      "Today I pause a moment before I pull away.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to run.",
      "One breath."
    ],
      [
      "I notice the urge to run.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to pull away from?",
      "What happens if I stay a moment?",
      "What can support me in this moment?"
    ],
      [
      "What am I trying to pull away from?",
      "What happens if I stay a moment?",
      "What can support me in this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment changes direction."
    ],
      [
      "A small moment changes direction."
    ]
    ),
    action: localizedGenderNode(
      "one breath before pulling back.",
      "one breath before pulling back."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step",
    opening: localizedGenderNode(
      [
      "Today I choose a small step that returns me to myself.",
      "Not a revolution."
    ],
      [
      "Today I choose a small step that returns me to myself.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly and look around.",
      "One breath."
    ],
      [
      "I breathe slowly and look around.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step can help me stay?",
      "When can I do it?",
      "What will help me remember?"
    ],
      [
      "What small step can help me stay?",
      "When can I do it?",
      "What will help me remember?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step.",
      "choose one small step."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ],
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause a moment before response.",
      "One breath."
    ],
      [
      "I pause a moment before response.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this feeling?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ],
      [
      "What did I learn about this feeling?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose a moment before response."
    ],
      [
      "I choose a moment before response."
    ]
    ),
    action: localizedGenderNode(
      "one breath + my sentence.",
      "one breath + my sentence."
    ),
  },
].map(buildNormalizedDay);

export const feelingStrangeNotBelongBlueprintEn = buildNormalizedPilotBlueprint({
  id: "feeling_strange_not_belong_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "feeling_strange_not_belong",
  category: "anxiety",
  journeyName: {
    he: "תחושת \"אני מוזר/ה, לא שייך/ת\"",
    en: "Feeling \"I'm strange, I don't belong\"",
    es: "Sentir \"soy extrano/a, no pertenezco\"",
  },
  days,
});

export default feelingStrangeNotBelongBlueprintEn;
